import styles from './invoiceSaleOperationForm.module.css'
import { Badge, FieldType, FieldValue, FormField, FormSeparator, O, option, ProvinceSelector, SelectField, StaticValue } from '../../../../../features/ui'
import { Provincia } from '../../../../../services/gob-ar'

type Props = {
    showPerceptions: boolean
    canEditPerceptions: boolean
    provinces: Provincia[]
    saleProvince: O<string>
    onChangeSaleProvince: (value?: FieldValue) => void
    customerGrossIncomeProvinces: string[]
    onAddGrossIncomeProvince: (value?: FieldValue) => void
    onRemoveGrossIncomeProvince: (province: string) => void
    isLoadingSaleProvince: boolean
}

export const invoicePerceptionFields = (props: Props): FormField[] => {
    const {
        showPerceptions,
        canEditPerceptions,
        provinces,
        saleProvince,
        onChangeSaleProvince,
        customerGrossIncomeProvinces,
        onAddGrossIncomeProvince,
        onRemoveGrossIncomeProvince,
        isLoadingSaleProvince
    } = props

    if (!showPerceptions) return []

    return [
        {
            name: 'percepciones-separator',
            type: FieldType.TEXT,
            render: () => <FormSeparator title="Percepciones" className={styles.separator} />
        },
        {
            name: 'saleProvince',
            type: FieldType.TEXT,
            label: 'Provincia de venta',
            render: () => (
                <SelectField
                    id="saleProvince"
                    value={saleProvince}
                    options={provinces.map(p => option(p.nombre, p.nombre))}
                    onChange={onChangeSaleProvince}
                    disabled={isLoadingSaleProvince || !canEditPerceptions}
                    className={styles.provinceSelect}
                />
            )
        },
        {
            name: 'grossIncomeProvinces',
            type: FieldType.TEXT,
            label: 'Provincias IIBB Cliente',
            render: () => !canEditPerceptions ? (
                customerGrossIncomeProvinces.length === 0 ? (
                    <StaticValue type={FieldType.TEXT} value="Cliente no inscripto en IIBB" />
                ) : (
                    <div className={styles.provinceChipsContainer}>
                        {customerGrossIncomeProvinces.map(province => (
                            <Badge key={province} label={province} kind="secondary" small />
                        ))}
                    </div>
                )
            ) : (
                <ProvinceSelector
                    provinces={customerGrossIncomeProvinces}
                    options={provinces.map(province => option(province.nombre, province.nombre))}
                    onAdd={province => onAddGrossIncomeProvince(province)}
                    onRemove={onRemoveGrossIncomeProvince}
                />
            )
        }
    ]
}
